'use client'

// Greeting band at top of Smart Inbox Dashboard.
// Pure helpers are exported for unit testing without a DOM renderer.

export function pickGreeting(now = new Date()) {
  const hour = (now.getUTCHours() + 8) % 24
  if (hour >= 5 && hour < 11) return '早安'
  if (hour >= 11 && hour < 17) return '午安'
  if (hour >= 17 && hour < 24) return '晚安'
  return '夜深了'
}

export function formatNTD(n) {
  const safe = typeof n === 'number' ? n : 0
  return 'NT$ ' + safe.toLocaleString('en-US')
}

export function buildSummary({ count, weeklyRevenue = 0 }) {
  const revenue = formatNTD(weeklyRevenue)
  if (count === 0) return `今天沒事，喝杯茶吧 · 本週收入 ${revenue}`
  return `今天 ${count} 件事要處理 · 本週收入 ${revenue}`
}

export default function HeroGreeting({ now, count = 0, weeklyRevenue = 0 }) {
  const greeting = pickGreeting(now)
  const summary = buildSummary({ count, weeklyRevenue })
  return (
    <header className="admin-hero-greeting">
      <h1 className="admin-hero-greeting__title">{greeting}</h1>
      <p className="admin-hero-greeting__summary admin-mono-tabular">{summary}</p>
    </header>
  )
}
